/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { gameGetGameMinecraftUserinfo } from "../../funcs/gameGetGameMinecraftUserinfo.js";
import { GetGameMinecraftUserinfoRequest$zodSchema } from "../../models/getgameminecraftuserinfoop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetGameMinecraftUserinfoRequest$zodSchema,
};

export const tool$gameGetGameMinecraftUserinfo: ToolDefinition<typeof args> = {
  name: "game-get-game-minecraft-userinfo",
  description: `查询 MC 玩家

只需要一个玩家的用户名，就能快速获取到他的正版皮肤和独一无二的UUID！

## 功能概述
这是一个基础但非常实用的接口。通过玩家当前的游戏内名称（Username），你可以查询到他对应的UUID（唯一标识符）和当前皮肤的URL地址。这是构建许多其他玩家相关服务的第一步。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await gameGetGameMinecraftUserinfo(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
